export interface CopiedAssetData {
  typeId: string;
  typeDisplayName: string;
  type?: string | null;
  // Optional instance-level overrides used when pasting.
  instanceOverrides?: Record<string, unknown>;
  copyKeyframes?: boolean;
  copyClips?: boolean;
  sourceInstanceId?: string;
  sourceSceneInstanceId?: string;
  // Transform copy options and start keyframe values
  copyPosition?: boolean;
  copyRotation?: boolean;
  copyScale?: boolean;
  startKeyframeTransform?: {
    position?: { x: number; y: number; z: number };
    rotation?: { x: number; y: number; z: number };
    scale?: { x: number; y: number; z: number };
  };
}

export interface CopyPasteService {
  copy(asset: CopiedAssetData): void;
  hasCopied(): boolean;
  peek(): CopiedAssetData | null;
  clear(): void;
}

export class InMemoryCopyPasteService implements CopyPasteService {
  private clipboard: CopiedAssetData | null = null;

  copy(asset: CopiedAssetData): void {
    this.clipboard = { ...asset };
  }

  hasCopied(): boolean {
    return this.clipboard !== null;
  }

  peek(): CopiedAssetData | null {
    return this.clipboard ? { ...this.clipboard } : null;
  }

  clear(): void {
    this.clipboard = null;
  }
}

export type { CopiedAssetData as CopyPayload };


